import React from 'react';
import {
  Container,
  Typography,
  Paper,
  Box,
  Divider
} from '@mui/material';

const Privacy = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Privacy Policy
        </Typography>
        
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Last updated: {new Date().toLocaleDateString()}
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ '& > *': { mb: 3 } }}>
          <Box>
            <Typography variant="h5" gutterBottom>
              1. Information We Collect
            </Typography>
            <Typography variant="body1" paragraph>
              When you use our Short Story Platform, we collect the following information:
            </Typography>
            <Typography variant="body1" component="ul" sx={{ pl: 3 }}>
              <li>Account information from Google OAuth (name, email, profile picture)</li>
              <li>Stories, comments, and other content you create</li>
              <li>Usage data and analytics to improve our service</li>
              <li>Technical information such as IP address and browser type</li>
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom>
              2. How We Use Your Information
            </Typography>
            <Typography variant="body1" paragraph>
              We use your information to:
            </Typography>
            <Typography variant="body1" component="ul" sx={{ pl: 3 }}>
              <li>Provide and maintain our story platform service</li>
              <li>Enable you to create, edit, and share stories</li>
              <li>Facilitate community interactions through comments</li>
              <li>Send important service notifications</li>
              <li>Improve our platform based on usage patterns</li>
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom>
              3. Information Sharing
            </Typography>
            <Typography variant="body1" paragraph>
              We do not sell, trade, or rent your personal information to third parties. We may share information only in the following circumstances:
            </Typography>
            <Typography variant="body1" component="ul" sx={{ pl: 3 }}>
              <li>With your explicit consent</li>
              <li>To comply with legal obligations</li>
              <li>To protect our rights and prevent fraud</li>
              <li>In connection with a business transfer or merger</li>
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom>
              4. Data Security
            </Typography>
            <Typography variant="body1" paragraph>
              We implement appropriate security measures to protect your personal information:
            </Typography>
            <Typography variant="body1" component="ul" sx={{ pl: 3 }}>
              <li>Encryption of data in transit and at rest</li>
              <li>Regular security audits and updates</li>
              <li>Access controls and authentication</li>
              <li>Secure cloud infrastructure (AWS)</li>
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom>
              5. Your Rights
            </Typography>
            <Typography variant="body1" paragraph>
              You have the right to:
            </Typography>
            <Typography variant="body1" component="ul" sx={{ pl: 3 }}>
              <li>Access your personal data</li>
              <li>Correct inaccurate information</li>
              <li>Delete your account and associated data</li>
              <li>Export your stories and content</li>
              <li>Opt out of non-essential communications</li>
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom>
              6. Cookies and Tracking
            </Typography>
            <Typography variant="body1" paragraph>
              We use cookies and similar technologies to:
            </Typography>
            <Typography variant="body1" component="ul" sx={{ pl: 3 }}>
              <li>Maintain your login session</li>
              <li>Remember your preferences</li>
              <li>Analyze platform usage</li>
              <li>Improve user experience</li>
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom>
              7. Third-Party Services
            </Typography>
            <Typography variant="body1" paragraph>
              Our platform integrates with the following third-party services:
            </Typography>
            <Typography variant="body1" component="ul" sx={{ pl: 3 }}>
              <li>Google OAuth for authentication</li>
              <li>AWS services for hosting and data storage</li>
              <li>CloudFront for content delivery</li>
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom>
              8. Data Retention
            </Typography>
            <Typography variant="body1" paragraph>
              We retain your information for as long as your account is active or as needed to provide services. 
              You may delete your account at any time, which will remove your personal data within 30 days.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom>
              9. Children's Privacy
            </Typography>
            <Typography variant="body1" paragraph>
              Our service is not intended for children under 13. We do not knowingly collect personal 
              information from children under 13. If you become aware that a child has provided us with 
              personal information, please contact us.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom>
              10. Changes to This Policy
            </Typography>
            <Typography variant="body1" paragraph>
              We may update this Privacy Policy from time to time. We will notify you of any changes by 
              posting the new Privacy Policy on this page and updating the "Last updated" date.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom>
              11. Contact Us
            </Typography>
            <Typography variant="body1" paragraph>
              If you have any questions about this Privacy Policy, please contact us at:
            </Typography>
            <Typography variant="body1">
              Email: support@chscw.club
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default Privacy;
